let timelineElements = [
  {
    id: 1,
    title: "Waking up to this reality...",
    description:
      "On this day, I woke up to reality a day I can't remember, but I knew I cried because why Nigeria🥲💔",
    date: "2001",
    icon: "work",
  },
  {
    id: 2,
    title: "print('Hello, World!')",
    description:
      "I started with Python and fell in love with it. And this is where it all began.🌚 And yeah I didn't start coding at the age of three, sad right?😭💔",
    date: "2018",
    icon: "school",
  },

  {
    id: 3,
    title: "Playing with Python",
    description:
      "Understood the basics of Python and built a simple whatsapp bot, face detection program, automated processes with python and selenium.",
    date: "2018",
    icon: "work",
  },

  {
    id: 4,
    title: "Tasted Kotlin🤢🤮 and UNITY",
    description:
      "Built a Tic-Tac-Toe app that took me weeks to finish. Gradle crashed my system multiple times but it was worth it and at that moment I knew Kotlin wasn't meant for me. And also built one 3D game with UNITY",
    date: "2018",
    icon: "school",
  },

  {
    id: 5,
    title: "University Phase",
    description:
      "Gained admission to a university in Cotonou. My university experience has been filled with PAIN, SUFFERING, and an atom of enjoyment.",
    date: "2018/2019",
    icon: "work",
  },

  {
    id: 6,
    title: "Where the real fun began",
    description:
      "Got passionate about Machine Learning and AI... Was also learning Web development(Html, CSS and JavaScript) and Wordpress",
    date: "2019",
    icon: "school",
  },

  {
    id: 7,
    title: "Machine Learning made me depressed",
    description:
      "Worked on my first model which I can't remember",
    date: "2019",
    icon: "work",
  },

  {
    id: 8,
    title: "Forex and Crypto",
    description:
      "Started learning about Forex Trading and Crypto Trading",
    date: "2019",
    icon: "school",
  },

  {
    id: 9,
    title: "Byee Machine Learning",
    description:
      "Built a crypto trading bot with python using Alpaca trade api",
    date: "2020",
    icon: "work",
  },

  {
    id: 10,
    title: "Blew my first Forex Account",
    description:
      "Acually have nothing to say. But just know how to set your stop loss kids",
    date: "2021",
    icon: "school",
  },

  {
    id: 11,
    title: "My very first remote Internship",
    description:
      "Interned as a Typescript Backend Engineer at Softkave(A startup company)",
    date: "2021",
    icon: "work",
  },

  {
    id: 12,
    title: "Finally done with Uni",
    description:
      "It's hard to believe that I didn't attend my matric, signout, and convocation because I couldn't see the purpose of it all. I just wanted to obtain the certificate and be done with it.",
    date: "2021/2022",
    icon: "school",
  },

  {
    id: 13,
    title: "Just had to REACT",
    description:
      "Started learning React and built my first chat web application using chatengine.io api",
    date: "January - 2022",
    icon: "work",
  },

  {
    id: 14,
    title: "Wordpress Gig",
    description:
      "Got my first wordpress gig to work on a Real Estate site",
    date: "January - 2022",
    icon: "school",
  },

  {
    id: 15,
    title: "React Gig",
    description:
      "Made my first six figures.",
    date: "July - 2022",
    icon: "work",
  },

  {
    id: 16,
    title: "Got a Job... I guess",
    description:
      "Got a job in a startup company as a web developer",
    date: "2022",
    icon: "school",
  },

  {
    id: 17,
    title: "NYSC(A Paramilitary Service... I guess🤔)",
    description:
      "Didn't want to do it in the first place but just had to.",
    date: "2023",
    icon: "work",
  },

  {
    id: 18,
    title: "Got a gig",
    description:
      "Taught people how to code(Web Development) in a tech training bootcamp. It was quite a fun experience and teaching is not easy fr fr.",
    date: "2023",
    icon: "school",
  },


];

export default timelineElements;
